import React from 'react';
import './level1.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import AudioContext from '../components/common/AudioContext';
import inlevel1 from '../audio/inlevel1.mp3';
import inlevel2 from '../audio/inlevel2.mp3';
import pic35 from '../assets/pic35.png'
import './howtoplayinstructions.css'
import Primaryctashort from '../components/common/primaryshortcta';
import Secondaryctashort from '../components/common/secondaryshort';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../pages/level1-start.css'
import pic115 from '../assets/pic115.png'
import './level2-start.css'
import pic124 from '../assets/pic124.png'
import pic125 from '../assets/pic125.png'
import { useEffect } from 'react';
import { useState } from 'react';
import pic89 from '../assets/pic89.png'
import pic149 from '../assets/pic149.png'
import pic150 from '../assets/pic150.png'
import pic151 from '../assets/pic151.png'
import pic152 from '../assets/pic152.png'
import pic153 from '../assets/pic153.png'
import pic154 from '../assets/pic154.png'
import './level3-start.css'
import pic156 from '../assets/pic156.png'
import pic157 from '../assets/pic157.png'
import pic158 from '../assets/pic158.png'
import pic159 from '../assets/pic159.png'
import pic155 from '../assets/pic155.png'
import inlevel3Ahmed from '../audio/Inlevel3-ahmed.mp3';
import inlevel3Sara from '../audio/Inlevel3-Sara.mp3';
import inlevel3Teyah from '../audio/Inlevel3-Teyah.mp3';
import Inlevel3mohammed from '../audio/inlevel3mohammed.mp3'
import pic182 from '../assets/pic182.png'
import pic230 from '../assets/pic230.png'
import Inlevel3mariam from '../audio/Inlevel3-mariam.mp3'

const Level3start = () => {
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [closing, setClosing] =useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
     const navigate = useNavigate();
           const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = soundVolume;
        audio.play().catch(() => {});

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (audioRef.current) audioRef.current.volume = soundVolume;
    }, [soundVolume]);


const handleBack = () => {
  setClosing(true);
   setTimeout(() => navigate(-1), 400);
};

const handleStart = () => {
  setClosing(true);
  setTimeout(() => navigate('/level3'), 400);
};

const getLevel3Audio = () => {
    if (selectedCharacter === 'Ahmad Amon') return inlevel3Ahmed;
    if (selectedCharacter === 'Sarah Idress') return inlevel3Sara;
    if (selectedCharacter === 'Teyah Ramses') return inlevel3Teyah;
    if (selectedCharacter === 'Mariam Lotus') return Inlevel3mariam;
    return Inlevel3mohammed; 
};

const level3Audio = getLevel3Audio();


    return ( 
        <>
<main className='level1--page'>
            <section className='levelbackground--page'>
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
 <>
          <audio ref={audioRef}
          src={level3Audio} 
           preload="auto" />

               <section className='settings-background'>
            <section className={`level2start-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Level 3</h2>
                        <h2 className='title2-container-settings'>Level 3</h2>
                    </div>
                    
                        <button className='circlecta-cont' >
                        <div onClick={handleStart}>
                            <div className='circle-red'>
                                <img className='close-img' src={pic35} alt='close'></img>
                            </div>
                        </div>
                    </button>
                </section>

                


                <section className='container-level2start'>

                    <figure className='container-imgs-leve3-start'>
                        <img className='pic1-leve2-start' src={pic149} alt='artifice 1'></img>
                        <img className='pic1-leve2-start' src={pic150} alt='artifice 2'></img>
                        <img className='pic1-leve2-start' src={pic151} alt='artifice 3'></img>
                        <img className='pic1-leve2-start' src={pic152} alt='artifice 4'></img>
                        <img className='pic1-leve2-start' src={pic153} alt='artifice 5'></img>
                        <img className='pic1-leve2-start' src={pic154} alt='artifice 6'></img>                        
                    </figure>
                    <section className='container-audio'>

                        <p className='para-mission'>Collect these six 
                            artifices and avoid touching obstacles</p>

                    </section>
                </section>



                <div className='container-continue-how-to-play' >
                    <div onClick={handleBack}>
                        <Secondaryctashort  title='Back'/>
                    </div>
                    <div onClick={handleStart}>
                    <Primaryctashort title='start' />
                    </div>
                 
                </div>



                </section>
            </section>
        </>
                         <div className='HUD-container-level-start'>


                        <div   className={`frame-Hud-level-start ${closing ? 'slide-down' : 'slide-up'}`}>
                            <div className='HUD-1-container-level-start'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>
                                <div className='quote-container'>
                                    <h2 className='lets-start-text'>Lets Start Now</h2>
                                </div>

                                <img className='charcter-level-start' 
                                src={
                                     selectedCharacter === 'Ahmad Amon'
                                    ? pic182  
                                    : selectedCharacter === 'Mariam Lotus'
                                    ?pic230                                    
                                    :selectedCharacter === 'Sarah Idress'
                                    ? pic115
                                    : selectedCharacter === 'Teyah Ramses'
                                        ? pic155
                                        : pic89
                                    }
                                // src={pic115} 
                                // src={pic89} 
                                alt='character'></img>




                            </div>


                        </div>
                    </div>
                <div className='background-and-obstacles-layer2-level3'>
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1-level3' src={pic157} alt='obstacle-1'/>
                        {/* <img className='obstacle2' src={pic58} alt='obstacle-2'/> */}
                        <img className='obstacle2-level3'  src={pic158} 
                        // src={pic59} 
                        alt='obstacle-3'/>

                        <img className='obstacle3-level2'  src={pic125} 
                        // src={pic59} 
                        alt='obstacle-3'/>

                        <img className='obstacle4-level2 '  src={pic125} 
                        // src={pic59} 
                        alt='obstacle-3'/>          

                         <img className='obstacle4-level3 '  src={pic124} 
                        // src={pic59} 
                        alt='obstacle-4'/>    


                         <img className='obstacle5-level3 '  src={pic159} 
                        // src={pic59} 
                        alt='obstacle-4'/>                                                                          

                    </div>
                </div>


             {/* <section className='container-items-home-page'>
               <section className='container-charcater-page'>
                    </section>
              </section> */}
   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 3' title2='Level 3 '
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement'
                 src={pic156}
                //   src={pic54} 
                  alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 

 
export default Level3start;